var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","align-center":"","justify-center":"","pt-0":"","pl-0":"","pr-0":""}},[_c('ComponentStatic',{on:{"activeMenu":_vm.activeMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }